import React from "react";

export default function LayoutsNegativeScreen() {
  return (
    <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-[75vh] tw-w-full tw-overflow-hidden">
      <img src="/NegativeScreens/Layouts.png" alt="" className="tw-w-[30rem]" />
    </div>
  );
}
